// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2729 ? "8213a2eb" : chunkId) + "." + {"174":"256eaf91a729dfef","1550":"b2e5b520b2693469","2729":"2b059ed4943d57e0","3012":"58d75d802d9ccfea","8803":"de1d06142baa041d"}[chunkId] + ".js";
};